export const PRE_HEADER = 0;
export const POST_HEADER = 1;
export const PRE_FORM_INNER_COMPONENT = 2;
export const STANDARD = 3;

/*
Group keys affect the propName of the fields, meaning it would affect API field lookups, so do NOT change these
 */
export const QUESTION_BRANCH_GROUP_KEY_INTENSITY = 'grp-intensity-';
export const QUESTION_BRANCH_GROUP_KEY_ABSOLUTE = 'grp-absolute-';
export const QUESTION_BRANCH_DATA_KEY_COMBINED = 'combined';
export const QUESTION_BRANCH_DATA_KEY_SEPARATED = 'separated';
export const QUESTION_BRANCH_DATA_KEY_UNKNOWN = 'unknown';
